<template>
  <a
    v-bind="linkAttrs"
    class="group relative block overflow-hidden rounded-2xl ring-1 ring-neutral-200 bg-neutral-900 shadow-sm"
    :class="rootClass"
    :style="fillStyle"
  >
    <img
      ref="img"
      :src="project.image"
      :alt="project.alt || project.title"
      :class="imageClassList"
      @load="onImageLoad"
    />
    <div
      class="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent pointer-events-none"
    ></div>
    <div
      class="absolute bottom-0 p-5 flex items-center justify-between w-full pointer-events-none"
    >
      <div>
        <p class="font-medium text-neutral-50 drop-shadow">
          {{ project.title }}
        </p>
        <p class="text-sm text-white/80">{{ project.subtitle }}</p>
      </div>
      <ExternalLink
        v-if="isExternal"
        :size="16"
        class="text-white/80 opacity-0 group-hover:opacity-100 transition-opacity"
      />
    </div>
  </a>
</template>

<script>
import { ExternalLink } from 'lucide-vue-next'

const CAROUSEL_HEIGHT = 320

export default {
  name: 'WorkProjectCard',
  components: { ExternalLink },
  props: {
    project: {
      type: Object,
      required: true
    },
    imageClass: {
      type: String,
      default: ''
    },
    rootClass: {
      type: [String, Array, Object],
      default: ''
    },
    fill: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aspectRatio: null
    }
  },
  computed: {
    isExternal() {
      return typeof this.project.url === 'string' && /^https?:\/\//i.test(this.project.url)
    },
    linkAttrs() {
      return {
        href: this.project.url || '#',
        target: this.isExternal ? '_blank' : undefined,
        rel: this.isExternal ? 'noopener noreferrer' : undefined
      }
    },
    fillStyle() {
      if (!this.fill) return undefined
      const ratio = this.aspectRatio || 16 / 10
      const width = Math.round(Math.min(Math.max(CAROUSEL_HEIGHT * ratio, 220), 560))
      return {
        height: `${CAROUSEL_HEIGHT}px`,
        width: `${width}px`,
        flexShrink: 0
      }
    },
    imageClassList() {
      if (this.fill) {
        return 'absolute inset-0 h-full w-full object-cover transition duration-500 group-hover:scale-105'
      }
      return [
        this.imageClass,
        'block w-full h-auto transition duration-500 group-hover:scale-105'
      ]
    }
  },
  methods: {
    onImageLoad(event) {
      const img = event.target
      if (img?.naturalWidth && img?.naturalHeight) {
        this.aspectRatio = img.naturalWidth / img.naturalHeight
        this.$emit('sized')
      }
    }
  }
}
</script>
